import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HeroStyleService {
  private heroRegex = /^"HERO (.+)"$/;
  private styleLoaded = new BehaviorSubject<string | null>(null);
  styleLoaded$ = this.styleLoaded.asObservable();

  constructor() {
    this.checkStylesLoaded();
  }

  private checkStylesLoaded(): void {
    // Wait for fonts to load (critical for font-family, font-size, etc.)
    document.fonts.ready.then(() => {
      const styleName = window.getComputedStyle(document.documentElement).getPropertyValue('--style');
      const isStyled = this.heroRegex.test(styleName);
      if (isStyled && !this.styleLoaded.getValue()) {
        this.styleLoaded.next(styleName);
      }
    });
  }
}
